:host {
  display: flex;
  flex-direction: column;
}

.stzh-card-navigation {
  position: relative;
  flex-grow: 1;
  display: flex;
  gap: space('small');
  background-color: $colorGrey10;

  &:hover {
    background-color: var(--stzh-color-secondary10);
  }

  &:hover &__arrow-icon {
    transform: translateX(4px);
  }

  &__wrapper {
    @include spaceCurve('padding-left', 'regular');
    display: flex;
    align-items: center;
    flex-grow: 1;
    // safe space padding top/bottom when it would go to three lines
    padding-top: var(--stzh-space-xsmall);
    padding-bottom: var(--stzh-space-xsmall);
  }

  &__title {
    @include font('heavy');
    @include fontCurve('teaser');
    @include wordWrap;
    color: $colorPrimary70;
    margin: 0;
  }

  &__title-link {
    display: block;
    font-family: inherit;
    font-size: inherit;
    padding: 0;
    appearance: none;
    background-color: transparent;
    border: none;
    color: $colorPrimary;
    text-decoration-line: none;
    transition: color $baseTransitionAnimationSpeed;
    border-radius: $buttonBorderRadius;
    cursor: pointer;

    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    &::after {
      z-index: 1;
    }
  }

  &__lead {
    @include fontCurve('p2');
    @include spaceCurve('margin-top', 'small');
    @include spaceCurve('margin-bottom', 'small');
  }

  &__arrow {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    height: 64px;
    color: $colorPrimary70;
    background-color: $colorSecondary30;
  }

  &__arrow-icon {
    transition: transform 150ms ease;
    --size: #{iconSize('large')};
  }

  /* Has lead variant */

  &--has-lead &__wrapper {
    @include spaceCurve('padding-right', 'regular');
    @include spaceCurve('padding-top', 'regular');
    @include spaceCurve('padding-bottom', 'large');
    flex-direction: column;
    align-items: flex-start;
  }

  &--has-lead &__arrow {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 44px;
    height: 44px;
  }

  /* Hyphens */
  &--hyphens &__title,
  &--hyphens &__title-link {
    hyphens: auto;
  }
}
